import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { environment } from '../../../environments/environment'
import { map } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private apiURL: string = environment.apiUrl + '/user'

  constructor(private http: HttpClient) {}

  private getHeaders(): HttpHeaders {
    return new HttpHeaders().set('Content-Type', 'application/json')
  }

  public changePassword(body: any) {
    const url: string = this.apiURL + '/change-password'
    return this.http.put(url, body, { headers: this.getHeaders() }).pipe(
      map((resource: { success: boolean }) => {
        return resource
      }),
    )
  }
}
